import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=63ab76ed&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=63ab76ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab76ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ab76ed')) {
      api.createRecord('63ab76ed', component.options)
    } else {
      api.reload('63ab76ed', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=63ab76ed&scoped=true&", function () {
      api.rerender('63ab76ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sHEF85j150bo/JS/comp/Voucher.vue"
export default component.exports